(() => {
  const SELECTORS = {
    section: 'section[id^="MainProduct-"]',
    product: '.product',
    mediaWrapper: '.product__media-wrapper',
    infoWrapper: '.product__info-wrapper',
    info: '.product__info-container',
    gallery: 'media-gallery',
    mediaList: '.product__media-list',
    mediaItem: '.product__media-item'
  };

  const directChildOf = (node, parent) => {
    let current = node;
    while (current && current.parentElement && current.parentElement !== parent) {
      current = current.parentElement;
    }
    return current && current.parentElement === parent ? current : null;
  };

  const visiblePriceText = (priceRoot) => {
    if (!priceRoot) return '';

    const priceComponent = priceRoot.querySelector('.price');
    const salePrice = priceComponent?.classList.contains('price--on-sale')
      ? priceRoot.querySelector('.price__sale .price-item--sale')
      : null;
    const regularPrice = priceRoot.querySelector('.price__regular .price-item--regular')
      || priceRoot.querySelector('.price-item--regular')
      || priceRoot.querySelector('.price-item');

    return (salePrice || regularPrice || priceRoot).textContent.replace(/\s+/g, ' ').trim();
  };

  const numericPrice = (priceText) => {
    const cleaned = priceText.replace(/[^0-9.,]/g, '').replace(/,/g, '');
    const value = Number.parseFloat(cleaned);
    return Number.isFinite(value) ? value : null;
  };

  const productWorld = (priceRoot) => {
    try {
      if (document.referrer) {
        const referrer = new URL(document.referrer, window.location.origin);
        const collectionMatch = referrer.pathname.match(/^\/collections\/(all|mainline|philosophy)(?:\/|$)/);

        if (collectionMatch && referrer.origin === window.location.origin) {
          return {
            href: `${referrer.pathname}${referrer.search}${referrer.hash}`,
            useHistoryBack: true
          };
        }
      }
    } catch (error) {}

    const price = numericPrice(visiblePriceText(priceRoot));
    if (price !== null) {
      return price > 300
        ? { href: '/collections/mainline', useHistoryBack: false }
        : { href: '/collections/philosophy', useHistoryBack: false };
    }

    return { href: '/collections/all', useHistoryBack: false };
  };

  const makeDisclosure = (label, contentNode) => {
    const details = document.createElement('details');
    details.className = 'adwoa-pdp-disclosure';

    const summary = document.createElement('summary');
    summary.className = 'adwoa-pdp-disclosure__summary';
    summary.textContent = label;

    const content = document.createElement('div');
    content.className = 'adwoa-pdp-disclosure__content';
    if (contentNode) content.appendChild(contentNode);

    details.append(summary, content);
    return details;
  };

  const ensureShippingLinkStyles = () => {
    if (document.getElementById('adwoa-pdp-shipping-link-styles')) return;

    const style = document.createElement('style');
    style.id = 'adwoa-pdp-shipping-link-styles';
    style.textContent = `
      .adwoa-pdp-shipping-link,
      .adwoa-pdp-shipping-link:link,
      .adwoa-pdp-shipping-link:visited,
      .adwoa-pdp-shipping-link:active {
        color: #000 !important;
        text-decoration: none !important;
        opacity: 1 !important;
      }

      @media (hover: hover) {
        .adwoa-pdp-shipping-link:hover {
          color: #000 !important;
          text-decoration: none !important;
          opacity: 0.5 !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const ensureThumbnailStyles = () => {
    if (document.getElementById('adwoa-pdp-thumbnail-styles')) return;

    const style = document.createElement('style');
    style.id = 'adwoa-pdp-thumbnail-styles';
    style.textContent = `
      .adwoa-pdp-thumb {
        box-sizing: border-box !important;
        border: 1px solid transparent !important;
        box-shadow: none !important;
        outline: 0 !important;
      }

      .adwoa-pdp-thumb::after {
        content: none !important;
        display: none !important;
      }

      .adwoa-pdp-thumb.is-active,
      .adwoa-pdp-thumb[aria-current='true'] {
        border: 1px solid #000 !important;
        box-shadow: none !important;
        outline: 0 !important;
      }

      @media screen and (min-width: 990px) {
        html.adwoa-product-page-active body .adwoa-pdp-section media-gallery .adwoa-pdp-thumbs {
          display: grid !important;
          grid-template-columns: repeat(var(--adwoa-pdp-thumb-count), minmax(0, 70px)) !important;
          justify-content: center !important;
          gap: clamp(4px, 0.6vw, 10px) !important;
          width: 100% !important;
          max-width: 100% !important;
          overflow: visible !important;
          overflow-x: visible !important;
          overflow-y: visible !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-section media-gallery .adwoa-pdp-thumb {
          flex: 0 1 auto !important;
          width: 100% !important;
          height: auto !important;
          min-width: 0 !important;
          max-width: none !important;
          margin: 0 !important;
          padding: 0 !important;
          aspect-ratio: 4 / 5;
        }

        html.adwoa-product-page-active body .adwoa-pdp-section media-gallery .adwoa-pdp-thumb img {
          display: block !important;
          width: 100% !important;
          height: 100% !important;
          min-width: 0 !important;
          max-width: 100% !important;
          object-fit: contain !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const ensureMobileProductStyles = () => {
    if (document.getElementById('adwoa-pdp-mobile-styles')) return;

    const style = document.createElement('style');
    style.id = 'adwoa-pdp-mobile-styles';
    style.textContent = `
      .adwoa-pdp-scroll-track {
        display: none;
      }

      @media screen and (max-width: 989px) {
        html.adwoa-product-page-active body .adwoa-product-layout {
          display: flex !important;
          flex-direction: column !important;
          width: 100% !important;
          max-width: none !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout > .adwoa-pdp-left {
          display: contents !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-back {
          display: none !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta {
          order: 2 !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
          margin: 24px 0 22px !important;
          text-align: center !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta .product__title,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta .product__title h1 {
          width: 100% !important;
          margin-right: auto !important;
          margin-left: auto !important;
          line-height: 1 !important;
          text-align: center !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta .product__title h1 {
          font-size: 39px !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] {
          display: block !important;
          align-self: stretch !important;
          width: 100% !important;
          margin-top: 9px !important;
          margin-bottom: 0 !important;
          text-align: center !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] .price,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] .price__container {
          width: 100% !important;
          text-align: center !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] .price.price--regular .price__regular,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] .price.price--on-sale .price__sale {
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          width: 100% !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] .price,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] .price-item {
          font-size: 25.2px !important;
          line-height: 1 !important;
          text-align: center !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-meta [id^='price-'] .price-item {
          display: inline-flex !important;
          justify-content: center !important;
          width: auto !important;
          margin-right: auto !important;
          margin-left: auto !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout > .adwoa-pdp-media {
          order: 1 !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          margin: 44px 0 0 !important;
          padding: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery,
        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery > slider-component,
        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery > .slider-mobile-gutter {
          display: block !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          overflow: visible !important;
          opacity: 1 !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery > slider-component {
          position: relative !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
          overflow: hidden !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list {
          --grid-mobile-horizontal-spacing: 0px;
          --grid-desktop-horizontal-spacing: 0px;
          display: flex !important;
          flex-wrap: nowrap !important;
          gap: 0 !important;
          column-gap: 0 !important;
          row-gap: 0 !important;
          width: 100% !important;
          max-width: none !important;
          height: auto !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow-x: auto !important;
          overflow-y: hidden !important;
          scroll-behavior: auto !important;
          scroll-snap-type: none !important;
          scroll-padding-inline: 0 !important;
          overscroll-behavior-inline: contain;
          scrollbar-width: none;
          touch-action: pan-x pan-y;
          -webkit-overflow-scrolling: touch;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list.grid--peek,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list.slider--mobile {
          width: 100% !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list.grid--peek::after,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list.slider::after {
          display: none !important;
          width: 0 !important;
          min-width: 0 !important;
          margin: 0 !important;
          padding: 0 !important;
          content: none !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list::-webkit-scrollbar {
          display: none !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item.is-active {
          box-sizing: border-box !important;
          display: block !important;
          flex: 0 0 100% !important;
          width: 100% !important;
          max-width: 100% !important;
          min-width: 100% !important;
          height: auto !important;
          aspect-ratio: var(--adwoa-mobile-media-ratio, 4 / 5) !important;
          margin: 0 !important;
          padding: 0 !important;
          scroll-snap-align: none !important;
          scroll-snap-stop: normal !important;
          opacity: 1 !important;
          visibility: visible !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list.grid--peek .product__media-item,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-list.slider--mobile .product__media-item,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item + .product__media-item {
          margin-right: 0 !important;
          margin-left: 0 !important;
          padding-right: 0 !important;
          padding-left: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item > .product-media-container,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item .product__modal-opener,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item .product__media {
          width: 100% !important;
          max-width: none !important;
          height: 100% !important;
          margin: 0 !important;
          padding-top: 0 !important;
          padding-right: 0 !important;
          padding-left: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item .product__media img,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item .product__media video,
        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item .product__media model-viewer {
          width: 100% !important;
          height: 100% !important;
          object-fit: cover !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media .product__media-item:first-child {
          margin-left: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery .adwoa-pdp-thumbs {
          display: none !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery .adwoa-pdp-scroll-track {
          position: absolute;
          left: 50%;
          bottom: 12px;
          z-index: 5;
          display: block;
          width: 64px;
          height: 1px;
          margin: 0;
          overflow: hidden;
          background: rgba(0, 0, 0, 0.22);
          pointer-events: none;
          transform: translateX(-50%);
        }

        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery .adwoa-pdp-scroll-track.is-hidden {
          display: none !important;
        }

        html.adwoa-product-page-active body .adwoa-pdp-media media-gallery .adwoa-pdp-scroll-indicator {
          position: absolute;
          inset: 0 auto 0 0;
          display: block;
          height: 1px;
          background: #000;
          transform: translateX(0);
          transition: left 90ms linear, transform 90ms linear;
          will-change: left, transform;
        }

        html.adwoa-product-page-active body .adwoa-product-layout > .adwoa-pdp-actions {
          order: 3 !important;
          display: flex !important;
          flex-direction: column !important;
          align-items: stretch !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          margin: 26px 0 0 !important;
          padding: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout > .adwoa-pdp-variants {
          order: 3 !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          margin: 26px 0 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-actions .adwoa-pdp-variants,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-variants,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-variants .product-form__input {
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout > .adwoa-pdp-buy {
          order: 4 !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          margin: 18px 0 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-actions .adwoa-pdp-buy {
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          margin: 18px 0 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-buy,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-buy product-form,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-buy .product-form,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-buy .form,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-buy .product-form__buttons,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-buy .product-form__submit,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-buy button[type='submit'],
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-inquiry-action,
        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-inquiry-trigger {
          display: block !important;
          width: 100% !important;
          max-width: none !important;
          min-width: 0 !important;
          margin-right: 0 !important;
          margin-left: 0 !important;
        }

        html.adwoa-product-page-active body .adwoa-product-layout .adwoa-pdp-details {
          order: 5 !important;
          width: 100% !important;
          max-width: none !important;
          margin-top: 30px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const splitDescription = (description) => {
    const groups = {
      details: document.createElement('div'),
      fit: document.createElement('div'),
      shipping: document.createElement('div')
    };

    Object.values(groups).forEach((group) => group.classList.add('adwoa-pdp-description'));

    let currentGroup = 'details';
    const nodes = Array.from(description.children);

    nodes.forEach((node) => {
      const text = node.textContent.replace(/\s+/g, ' ').trim();
      const normalized = text.toLowerCase();

      if (/^(size\s*&\s*fit|size\s+and\s+fit|sizing|fit)$/.test(normalized)) {
        currentGroup = 'fit';
        return;
      }

      if (/^(shipping|shipping\s*&\s*returns|shipping\s+and\s+returns)$/.test(normalized)) {
        currentGroup = 'shipping';
        return;
      }

      const hasMedia = Boolean(node.querySelector('img, video, iframe, model-viewer'));
      if (!text && !hasMedia) return;

      groups[currentGroup].appendChild(node);
    });

    return groups;
  };

  const setupGallery = (gallery) => {
    if (!gallery || gallery.dataset.adwoaPdpGallery === 'true') return;

    const mediaList = gallery.querySelector(SELECTORS.mediaList);
    const viewer = gallery.querySelector('slider-component');
    if (!mediaList || !viewer) return;

    const mediaItems = Array.from(mediaList.querySelectorAll(SELECTORS.mediaItem));
    if (!mediaItems.length) return;

    const mobileGalleryQuery = window.matchMedia('(max-width: 989px)');
    const listProperties = [
      'display',
      'flex-wrap',
      'gap',
      'column-gap',
      'row-gap',
      'width',
      'max-width',
      'margin',
      'padding'
    ];
    const itemProperties = [
      'box-sizing',
      'display',
      'flex',
      'width',
      'min-width',
      'max-width',
      'height',
      'aspect-ratio',
      'margin',
      'padding'
    ];
    const containerProperties = ['width', 'max-width', 'height', 'margin', 'padding'];
    const mediaProperties = ['width', 'max-width', 'height', 'margin', 'padding-top', 'padding-right', 'padding-left'];
    const visualProperties = ['width', 'height', 'object-fit'];

    const clearProperties = (node, properties) => {
      properties.forEach((property) => node.style.removeProperty(property));
    };

    const syncMobileGalleryLayout = () => {
      if (mobileGalleryQuery.matches) {
        mediaList.classList.remove('grid', 'grid--peek');
        mediaList.classList.add('adwoa-pdp-mobile-rail');
        mediaList.style.setProperty('display', 'flex', 'important');
        mediaList.style.setProperty('flex-wrap', 'nowrap', 'important');
        mediaList.style.setProperty('gap', '0', 'important');
        mediaList.style.setProperty('column-gap', '0', 'important');
        mediaList.style.setProperty('row-gap', '0', 'important');
        mediaList.style.setProperty('width', '100%', 'important');
        mediaList.style.setProperty('max-width', 'none', 'important');
        mediaList.style.setProperty('margin', '0', 'important');
        mediaList.style.setProperty('padding', '0', 'important');

        mediaItems.forEach((item) => {
          const container = item.querySelector(':scope > .product-media-container');
          const media = item.querySelector('.product__media');
          const visual = media?.querySelector('img, video, model-viewer');
          const ratioPercent = Number.parseFloat(container?.style.getPropertyValue('--ratio-percent'));
          const intrinsicRatio = visual instanceof HTMLImageElement && visual.naturalWidth && visual.naturalHeight
            ? visual.naturalWidth / visual.naturalHeight
            : null;
          const mediaRatio = intrinsicRatio || (ratioPercent > 0 ? 100 / ratioPercent : 0.8);

          item.style.setProperty('--adwoa-mobile-media-ratio', String(mediaRatio));
          item.style.setProperty('box-sizing', 'border-box', 'important');
          item.style.setProperty('display', 'block', 'important');
          item.style.setProperty('flex', '0 0 100%', 'important');
          item.style.setProperty('width', '100%', 'important');
          item.style.setProperty('min-width', '100%', 'important');
          item.style.setProperty('max-width', '100%', 'important');
          item.style.setProperty('height', 'auto', 'important');
          item.style.setProperty('aspect-ratio', `${mediaRatio} / 1`, 'important');
          item.style.setProperty('margin', '0', 'important');
          item.style.setProperty('padding', '0', 'important');

          if (container) {
            container.style.setProperty('width', '100%', 'important');
            container.style.setProperty('max-width', 'none', 'important');
            container.style.setProperty('height', '100%', 'important');
            container.style.setProperty('margin', '0', 'important');
            container.style.setProperty('padding', '0', 'important');
          }

          if (media) {
            media.style.setProperty('width', '100%', 'important');
            media.style.setProperty('max-width', 'none', 'important');
            media.style.setProperty('height', '100%', 'important');
            media.style.setProperty('margin', '0', 'important');
            media.style.setProperty('padding-top', '0', 'important');
            media.style.setProperty('padding-right', '0', 'important');
            media.style.setProperty('padding-left', '0', 'important');
          }

          if (visual) {
            visual.style.setProperty('width', '100%', 'important');
            visual.style.setProperty('height', '100%', 'important');
            visual.style.setProperty('object-fit', 'cover', 'important');
          }
        });
        return;
      }

      mediaList.classList.remove('adwoa-pdp-mobile-rail');
      mediaList.classList.add('grid', 'grid--peek');
      clearProperties(mediaList, listProperties);
      mediaItems.forEach((item) => {
        clearProperties(item, itemProperties);
        item.style.removeProperty('--adwoa-mobile-media-ratio');
        const container = item.querySelector(':scope > .product-media-container');
        if (container) clearProperties(container, containerProperties);
        const media = item.querySelector('.product__media');
        if (media) clearProperties(media, mediaProperties);
        const visual = media?.querySelector('img, video, model-viewer');
        if (visual) clearProperties(visual, visualProperties);
      });
    };

    syncMobileGalleryLayout();
    if (typeof mobileGalleryQuery.addEventListener === 'function') {
      mobileGalleryQuery.addEventListener('change', syncMobileGalleryLayout);
    } else {
      mobileGalleryQuery.addListener(syncMobileGalleryLayout);
    }

    gallery.dataset.adwoaPdpGallery = 'true';

    const rail = document.createElement('div');
    rail.className = 'adwoa-pdp-thumbs';
    rail.setAttribute('role', 'list');
    rail.setAttribute('aria-label', 'Product images');

    const scrollTrack = document.createElement('div');
    scrollTrack.className = 'adwoa-pdp-scroll-track';
    scrollTrack.setAttribute('aria-hidden', 'true');

    const scrollIndicator = document.createElement('span');
    scrollIndicator.className = 'adwoa-pdp-scroll-indicator';
    scrollTrack.appendChild(scrollIndicator);

    const buttons = [];

    mediaItems.forEach((item, index) => {
      const mediaId = item.dataset.mediaId;
      const sourceImage = item.querySelector('img');
      if (!mediaId || !sourceImage) return;

      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'adwoa-pdp-thumb';
      button.dataset.mediaId = mediaId;
      button.setAttribute('role', 'listitem');
      button.setAttribute('aria-label', `View product image ${index + 1}`);

      const image = document.createElement('img');
      image.src = sourceImage.currentSrc || sourceImage.src;
      if (sourceImage.srcset) image.srcset = sourceImage.srcset;
      image.alt = sourceImage.alt || '';
      image.loading = index < 4 ? 'eager' : 'lazy';

      button.appendChild(image);
      rail.appendChild(button);
      buttons.push(button);
    });

    if (!buttons.length) return;
    ensureThumbnailStyles();
    rail.style.setProperty('--adwoa-pdp-thumb-count', String(buttons.length));
    scrollTrack.classList.toggle('is-hidden', mediaItems.length < 2);
    scrollIndicator.style.width = `${Math.max(12, 64 / mediaItems.length)}px`;
    viewer.appendChild(scrollTrack);
    gallery.appendChild(rail);

    let fadeTimer = null;
    let mobileScrollFrame = null;

    const LEFT_CURSOR = 'url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2232%22 height=%2232%22 viewBox=%220 0 32 32%22%3E%3Cpath d=%22M20 7 11 16l9 9%22 fill=%22none%22 stroke=%22%23000%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/%3E%3C/svg%3E") 16 16, w-resize';
    const RIGHT_CURSOR = 'url("data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%2232%22 height=%2232%22 viewBox=%220 0 32 32%22%3E%3Cpath d=%22m12 7 9 9-9 9%22 fill=%22none%22 stroke=%22%23000%22 stroke-width=%222%22 stroke-linecap=%22round%22 stroke-linejoin=%22round%22/%3E%3C/svg%3E") 16 16, e-resize';

    const currentItem = () => mediaItems.find((item) => item.classList.contains('is-active')) || mediaItems[0];

    const isImageItem = (item) => Boolean(item?.querySelector('img'))
      && !item?.querySelector('video, iframe, model-viewer, .deferred-media');

    const syncRail = () => {
      const activeId = currentItem()?.dataset.mediaId;
      buttons.forEach((button) => {
        const active = button.dataset.mediaId === activeId;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    const syncScrollIndicator = (targetItem = null) => {
      if (mediaItems.length < 2) return;

      const resolvedItem = targetItem || currentItem();
      const resolvedIndex = Math.max(0, mediaItems.indexOf(resolvedItem));
      const progressPercent = (resolvedIndex / (mediaItems.length - 1)) * 100;

      scrollIndicator.style.left = `${progressPercent}%`;
      scrollIndicator.style.transform = `translateX(-${progressPercent}%)`;
    };

    const activateMedia = (mediaId) => {
      if (!mediaId) return;
      const nextItem = mediaItems.find((item) => item.dataset.mediaId === mediaId);
      if (!nextItem) return;

      if (window.innerWidth < 990) {
        mediaItems.forEach((item) => item.classList.toggle('is-active', item === nextItem));
        mediaList.scrollTo({ left: nextItem.offsetLeft, behavior: 'smooth' });
        syncRail();
        syncScrollIndicator(nextItem);
        return;
      }

      if (currentItem()?.dataset.mediaId === mediaId) return;

      viewer.classList.add('adwoa-pdp-viewer-changing');
      window.clearTimeout(fadeTimer);

      fadeTimer = window.setTimeout(() => {
        mediaItems.forEach((item) => item.classList.toggle('is-active', item === nextItem));

        if (typeof gallery.playActiveMedia === 'function') {
          gallery.playActiveMedia(nextItem);
        } else if (typeof window.pauseAllMedia === 'function') {
          window.pauseAllMedia();
        }

        syncRail();
        requestAnimationFrame(() => {
          requestAnimationFrame(() => viewer.classList.remove('adwoa-pdp-viewer-changing'));
        });
      }, 80);
    };

    const updateViewerCursor = (clientX) => {
      if (window.innerWidth < 990 || mediaItems.length < 2 || !isImageItem(currentItem())) {
        viewer.style.cursor = '';
        return;
      }

      const bounds = viewer.getBoundingClientRect();
      viewer.style.cursor = clientX < bounds.left + (bounds.width / 2) ? LEFT_CURSOR : RIGHT_CURSOR;
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => activateMedia(button.dataset.mediaId));
    });

    const mediaObserver = new MutationObserver(() => {
      syncRail();
      syncScrollIndicator();
    });
    mediaObserver.observe(mediaList, { subtree: true, attributes: true, attributeFilter: ['class'] });

    if ('IntersectionObserver' in window) {
      const mediaVisibilityObserver = new IntersectionObserver((entries) => {
        const visibleEntry = entries
          .filter((entry) => entry.isIntersecting)
          .sort((first, second) => second.intersectionRatio - first.intersectionRatio)[0];

        if (visibleEntry) syncScrollIndicator(visibleEntry.target);
      }, {
        root: mediaList,
        threshold: [0.5, 0.75, 0.95]
      });

      mediaItems.forEach((item) => mediaVisibilityObserver.observe(item));
    }

    syncRail();
    requestAnimationFrame(() => syncScrollIndicator());

    mediaList.addEventListener('scroll', () => {
      if (window.innerWidth >= 990) return;
      if (mobileScrollFrame) cancelAnimationFrame(mobileScrollFrame);

      mobileScrollFrame = requestAnimationFrame(() => {
        const viewportCenter = mediaList.scrollLeft + (mediaList.clientWidth / 2);
        let nextItem = mediaItems[0];
        let closestDistance = Number.POSITIVE_INFINITY;

        mediaItems.forEach((item) => {
          const itemCenter = item.offsetLeft + (item.offsetWidth / 2);
          const distance = Math.abs(itemCenter - viewportCenter);
          if (distance < closestDistance) {
            closestDistance = distance;
            nextItem = item;
          }
        });

        mediaItems.forEach((item) => item.classList.toggle('is-active', item === nextItem));
        syncRail();
        syncScrollIndicator(nextItem);

        const activeButton = buttons.find((button) => button.dataset.mediaId === nextItem.dataset.mediaId);
        if (activeButton && rail.scrollWidth > rail.clientWidth) {
          rail.scrollTo({
            left: activeButton.offsetLeft - ((rail.clientWidth - activeButton.offsetWidth) / 2),
            behavior: 'smooth'
          });
        }
      });
    }, { passive: true });

    viewer.addEventListener('mousemove', (event) => updateViewerCursor(event.clientX));
    viewer.addEventListener('mouseleave', () => {
      viewer.style.cursor = '';
    });

    viewer.addEventListener('click', (event) => {
      if (window.innerWidth < 990) return;

      const activeItem = currentItem();
      if (!isImageItem(activeItem)) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (mediaItems.length < 2) return;

      const index = Math.max(0, mediaItems.indexOf(activeItem));
      const bounds = viewer.getBoundingClientRect();
      const clickedLeft = event.clientX < bounds.left + (bounds.width / 2);
      const nextIndex = clickedLeft
        ? (index - 1 + mediaItems.length) % mediaItems.length
        : (index + 1) % mediaItems.length;

      activateMedia(mediaItems[nextIndex].dataset.mediaId);
    }, true);
  };

  const setupProductPage = (section) => {
    if (!section || section.dataset.adwoaProductPage === 'true') return;

    const product = section.querySelector(SELECTORS.product);
    const mediaWrapper = product?.querySelector(`:scope > ${SELECTORS.mediaWrapper}`) || product?.querySelector(SELECTORS.mediaWrapper);
    const infoWrapper = product?.querySelector(`:scope > ${SELECTORS.infoWrapper}`) || product?.querySelector(SELECTORS.infoWrapper);
    const info = infoWrapper?.querySelector(SELECTORS.info);
    const gallery = mediaWrapper?.querySelector(SELECTORS.gallery);

    if (!product || !mediaWrapper || !infoWrapper || !info || !gallery) return;

    section.dataset.adwoaProductPage = 'true';
    ensureMobileProductStyles();
    document.documentElement.classList.add('adwoa-product-page-active');
    section.classList.add('adwoa-pdp-section');
    product.classList.add('adwoa-product-layout');
    mediaWrapper.classList.add('adwoa-pdp-media');
    infoWrapper.classList.add('adwoa-pdp-source-info');

    const title = info.querySelector('.product__title');
    const meta = directChildOf(title, info);
    const priceRoot = meta?.querySelector('[id^="price-"]') || info.querySelector('[id^="price-"]');

    const left = document.createElement('aside');
    left.className = 'adwoa-pdp-left';
    left.style.alignSelf = 'center';
    left.style.setProperty('padding-top', '0', 'important');
    product.insertBefore(left, mediaWrapper);

    if (meta) {
      meta.classList.add('adwoa-pdp-meta');

      const world = productWorld(priceRoot);
      const backLink = document.createElement('a');
      backLink.className = 'adwoa-pdp-back';
      backLink.href = world.href;
      backLink.textContent = '← BACK';

      if (world.useHistoryBack) {
        backLink.addEventListener('click', (event) => {
          event.preventDefault();
          window.history.back();
        });
      }

      meta.prepend(backLink);
      left.appendChild(meta);
    }

    const detailsGroup = document.createElement('div');
    detailsGroup.className = 'adwoa-pdp-details';

    const description = info.querySelector('.product__description');
    const descriptionGroups = description
      ? splitDescription(description)
      : { details: document.createElement('div'), fit: document.createElement('div'), shipping: document.createElement('div') };

    if (descriptionGroups.details.childNodes.length) {
      detailsGroup.appendChild(makeDisclosure('DETAILS', descriptionGroups.details));
    }

    const popupCandidates = Array.from(info.querySelectorAll('.product-popup-modal__opener'));
    const fitPopup = popupCandidates.find((node) => /size|sizing|fit/i.test(node.textContent));
    if (fitPopup) {
      const fitRoot = directChildOf(fitPopup, info) || fitPopup;
      fitRoot.classList.add('adwoa-pdp-fit-content');
      descriptionGroups.fit.appendChild(fitRoot);
    }

    if (descriptionGroups.fit.childNodes.length) {
      detailsGroup.appendChild(makeDisclosure('FIT', descriptionGroups.fit));
    }

    const shippingLink = document.createElement('a');
    ensureShippingLinkStyles();
    shippingLink.className = 'adwoa-pdp-shipping-link';
    shippingLink.href = '/pages/shipping-policy';
    shippingLink.textContent = 'SHIPPING & RETURNS';
    detailsGroup.appendChild(shippingLink);
    left.appendChild(detailsGroup);

    const variantPicker = info.querySelector('variant-radios, variant-selects');
    const variantRoot = directChildOf(variantPicker, info) || variantPicker;
    if (variantRoot) {
      variantRoot.classList.add('adwoa-pdp-variants');
      variantRoot.querySelectorAll('.product-form__input').forEach((field) => {
        const legend = field.querySelector('.form__label');
        if (legend && legend.textContent.trim().toLowerCase() === 'size') field.classList.add('adwoa-pdp-size');
      });
      product.appendChild(variantRoot);
    }

    const productForm = info.querySelector('product-form');
    const buyRoot = directChildOf(productForm, info) || productForm;
    if (buyRoot) {
      buyRoot.classList.add('adwoa-pdp-buy');
      product.appendChild(buyRoot);
    }

    const submitButton = buyRoot?.querySelector('.product-form__submit');
    const nativeSubmitLabel = submitButton?.querySelector(':scope > span');
    let customSubmitLabel = submitButton?.querySelector('.adwoa-pdp-button-label');

    if (submitButton && !customSubmitLabel) {
      customSubmitLabel = document.createElement('span');
      customSubmitLabel.className = 'adwoa-pdp-button-label';
      submitButton.insertBefore(customSubmitLabel, submitButton.firstChild);
    }

    const syncPurchaseButton = () => {
      if (!submitButton || !customSubmitLabel) return;
      const nativeLabel = nativeSubmitLabel?.textContent.replace(/\s+/g, ' ').trim() || '';
      const soldOut = submitButton.disabled || /sold out|unavailable/i.test(nativeLabel);
      const displayLabel = soldOut ? 'SOLD OUT' : 'ADD TO BAG';

      if (customSubmitLabel.textContent !== displayLabel) customSubmitLabel.textContent = displayLabel;
    };

    syncPurchaseButton();

    if (submitButton) {
      const purchaseObserver = new MutationObserver(syncPurchaseButton);
      purchaseObserver.observe(submitButton, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
    }

    if (priceRoot) {
      const priceObserver = new MutationObserver(syncPurchaseButton);
      priceObserver.observe(priceRoot, { subtree: true, childList: true, characterData: true });
    }

    variantRoot?.addEventListener('change', () => requestAnimationFrame(syncPurchaseButton));

    setupGallery(gallery);
  };

  const boot = () => {
    document.querySelectorAll(SELECTORS.section).forEach(setupProductPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
